import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm"
import "github-markdown-css/github-markdown.css";

import { acronymFromPath, scrollTop, goToPage } from '../../util';
import { fetchWhitelistIfNeeded, changeNavMenu } from '../../data/actions';
import NavContainer from './nav';
import DOMPurify from 'dompurify';

class DocsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navItems: [],
      pages: {},
      isloading: false,
      error: false,
      // store fetch failures { slug, status }
      docContentStatus: [],
    };

    this.cacheControl = (new Date()).toISOString().split(":")[0].replaceAll("-","");
    this.handleClickPage = this.handleClickPage.bind(this);

    //get json with navigation and render sidebar
    this.fetchNavItems();
  }

  componentDidMount() {
    const { fetchWhitelist, sectionHash = 'sla' } = this.props;
    const { changeNavMenu } = this.props;

    changeNavMenu(sectionHash);
    fetchWhitelist();
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { match } = this.props;
    const { navItems, pages, error, isloading } = nextState;
    const slug = acronymFromPath(match.params.slug);

    if (pages[slug] && !isloading) {
      return true;
    }
    if (navItems.length || error) {
      return true;
    }
    return false;
  }

  fetchNavItems = async () => {
    const {sectionFolder = 'sla'} = this.props

    let res = await fetch(`/assets/docs/${sectionFolder}/index.json?ttl=${this.cacheControl}`);
    if (res.ok) {
      let navItems = await res.json();
      if (navItems.navigation) {
        this.setState((actualState) => {
          return {
            ...actualState,
            navItems: navItems.navigation,
          };
        });
      }
    } else {
      console.error('Error fetching ', res.url, res.status);
      this.setState((actualState) => {
        return {
          ...actualState,
          error: true,
          isloading: false,
        };
      });
    }
  };

  getDocContent = async (pageData, slug) => {
    let { pages } = this.state;
    if (!pageData || !pageData.file) {
      return false;
    }

    let res = await fetch(pageData.file + `?ttl=${this.cacheControl}`);
    if (res.ok) {
      let text = await res.text();
      this.setState((actualState) => {
        return {
          ...actualState,
          pages: {
            ...pages,
            [pageData.id]: {
              ...pages[pageData.id],
              html: text,
            },
          },
          isloading: false,
          error: false,
        };
      });
    } else {
      console.error('Error fetching getDocContent() :: ', res.url, res.status);
      this.setState((actualState) => {
        let newFailure
        if (!actualState.docContentStatus.some((entry) => entry.slug === slug)) {
          newFailure = { slug, status: res.status }
        }
        return {
          ...actualState,
          error: true,
          isloading: false,
          ...(!newFailure ? {} : { docContentStatus: [...actualState.docContentStatus, newFailure] })
        };
      });
    }
    return true
  };

  sanitizeHtml = (html) => {
    return DOMPurify.sanitize(html, {USE_PROFILES: {html: true}, ADD_TAGS: ['wb-icon']});
  }

  handleClickPage(e) {
    let link = e.target;
    if (link.hasAttribute('href')) {
      //if inner paths
      if (link.getAttribute('href')[0] === '/') {
        e.preventDefault();
        goToPage(link.getAttribute('href'));
        scrollTop();
      }
    }
  }

  render() {
    const { match, sectionHash, sectionFolder } = this.props;
    const { navItems, pages, isloading, error } = this.state;
    const slug = acronymFromPath(match.params.slug) || (navItems && navItems[1] && navItems[1].id ? navItems[1].id : '') ;
    let pageInfo = navItems.find((x) => x.id == slug);
    let pageInfoRes = false;

    const notFoundBefore = !!this.state.docContentStatus.find((entry) => entry.slug === slug && entry.status === 404)

    if (slug && !pages[slug] && !isloading && !notFoundBefore) {
      pageInfoRes = this.getDocContent(pageInfo, slug)
        .then((res) => console.info(`Page ${slug} loaded.`));
    }

    return (
      <div className="body body__sidebar">
        <NavContainer sectionHash={sectionHash} sectionFolder={sectionFolder} slug={slug} navItems={navItems} />
        <div className="content">
          <div className="page-content">

              <React.Fragment>
                {!isloading && Object.keys(pages).length > 0 && pages[slug] ? (
                  <>
                    <div className="page-header">
                      <h2 className="page-header__title">{pageInfo ? pageInfo.text : ''}</h2>
                    </div>
                    <div className="page-body">
                      {
                        pageInfo.file.endsWith(".md")
                          ? <div className="page-body__section markdown-body" style={{background:'#fff'}}>
                            <ReactMarkdown remarkPlugins={[gfm]} children={pages[slug].html} />
                          </div>
                          : <div onClick={this.handleClickPage} dangerouslySetInnerHTML={{ __html: this.sanitizeHtml(pages[slug].html) }} />
                      }
                    </div>
                  </>
                ) : (
                  <div>
                    {!error? (
                      <div className="page-body__section">
                        <div className="loader-container">
                          <wb-spinner mode="dark" />
                        </div>
                      </div>
                    ) : (
                      <div className="page-body page-body__message_box">Error loading page content</div>
                    )}
                  </div>
                )}
              </React.Fragment>

          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  const { isWhitelisted } = state.tenants;
  const { navMenuSelected } = state.global;

  return {
    navMenuSelected,
    isWhitelisted,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeNavMenu: (navMenuSelected) => {
      dispatch(changeNavMenu(navMenuSelected));
    },
    fetchWhitelist: () => {
      dispatch(fetchWhitelistIfNeeded());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DocsContainer);
